import React from 'react';
import clsx from 'clsx';
import { ChatMessagesProps, ChatRole } from '@/interfaces';

interface Props {
	item: ChatMessagesProps;
	children: React.ReactNode;
}

export const WrapperMessage = ({ item, children }: Props) => {
	const getBgColorByRole = (role: ChatRole | undefined): string => {
		switch (role) {
			case 'user':
			case 'client':
				return 'bg-purple-35';
			case 'bot':
				return 'bg-grey-10';
			case 'system':
			case 'lawyer':
			default:
				return 'bg-green-20';
		}
	};
	return (
		<div
			className={clsx('flex flex-col gap-3', {
				'items-end': item.role === 'user' || item.role === 'client',
			})}
		>
			<div
				className={clsx(
					'p-3 rounded-2xl w-fit',
					getBgColorByRole(item.role),
					item.role === 'user' || item.role === 'client'
						? 'rounded-tr-none'
						: 'rounded-tl-none'
				)}
			>
				{children}
			</div>
		</div>
	);
};
